import React from 'react';
import * as Styled from './styles';

export const UpcomingRounds = () => {
    return (
        <Styled.Wrapper>
            <Styled.DescriptionWrapper>
                <Styled.Dates>
                    Cheltenham Festival 10th&#45;13th March 2026
                </Styled.Dates>
                <Styled.Title>WHAT&apos;S COMING UP?</Styled.Title>
                <Styled.Blurb>
                    <strong>Enter ITV7 for free</strong> and 7 correct winners
                    could land you the jackpot prize!
                </Styled.Blurb>
            </Styled.DescriptionWrapper>
            <Styled.ScheduleWrapper>
                <Styled.DayWrapper>
                    <Styled.DateWrapper>
                        <Styled.DayNumber>Day</Styled.DayNumber>
                        <Styled.DayNumber>One</Styled.DayNumber>
                    </Styled.DateWrapper>
                    <Styled.InfoWrapper>
                        <Styled.DayInfo>
                            We kick off the Cheltenham Festival with our first{' '}
                            <Styled.Jackpot>&pound;250,000</Styled.Jackpot>{' '}
                            jackpot.
                        </Styled.DayInfo>
                    </Styled.InfoWrapper>
                </Styled.DayWrapper>
                <Styled.DayWrapper>
                    <Styled.DateWrapper>
                        <Styled.DayNumber>Day</Styled.DayNumber>
                        <Styled.DayNumber>Two</Styled.DayNumber>
                    </Styled.DateWrapper>
                    <Styled.InfoWrapper>
                        <Styled.DayInfo>
                            Another day, another{' '}
                            <Styled.Jackpot>&pound;250,000</Styled.Jackpot>{' '}
                            jackpot up for grabs.
                        </Styled.DayInfo>
                    </Styled.InfoWrapper>
                </Styled.DayWrapper>
                <Styled.DayWrapper>
                    <Styled.DateWrapper>
                        <Styled.DayNumber>Day</Styled.DayNumber>
                        <Styled.DayNumber>Three</Styled.DayNumber>
                    </Styled.DateWrapper>
                    <Styled.InfoWrapper>
                        <Styled.DayInfo>
                            <Styled.Jackpot>&pound;250,000</Styled.Jackpot> on
                            the line today, don&apos;t miss out.
                        </Styled.DayInfo>
                    </Styled.InfoWrapper>
                </Styled.DayWrapper>
                <Styled.DayWrapper>
                    <Styled.DateWrapper>
                        <Styled.DayNumber>Day</Styled.DayNumber>
                        <Styled.DayNumber>Four</Styled.DayNumber>
                    </Styled.DateWrapper>
                    <Styled.InfoWrapper>
                        <Styled.DayInfoWithBottomGutter>
                            For Gold Cup Day, if the jackpot hasn&apos;t been
                            won on the first three days, we&apos;re guaranteeing
                            a quarter of a million pounds! Plus, enter our ITV7
                            Gold Cup Sweepstake competition, for a chance to win
                            a prize bundle worth{' '}
                            <Styled.Jackpot>&pound;50,000</Styled.Jackpot>. One
                            winner. Guaranteed.
                        </Styled.DayInfoWithBottomGutter>
                    </Styled.InfoWrapper>
                </Styled.DayWrapper>
            </Styled.ScheduleWrapper>
        </Styled.Wrapper>
    );
};

UpcomingRounds.defaultProps = {};

UpcomingRounds.propTypes = {};

export default UpcomingRounds;
